import { Link, useLocation } from "react-router-dom";

const segmentLabels: Record<string, string> = {
  persianas: "Persianas",
  toldos: "Toldos",
  mosquiteras: "Mosquiteras",
  zonas: "Zonas",
  contacto: "Contacto",
  presupuesto: "Presupuesto",
  "sobre-nosotros": "Sobre Nosotros",
  "aviso-legal": "Aviso Legal",
  "politica-privacidad": "Política de Privacidad",
  "politica-cookies": "Política de Cookies",
  "motor-persianas": "Motor para Persianas",
  "persianas-aluminio": "Persianas de Aluminio",
  "persianas-electricas": "Persianas Eléctricas",
  "persianas-pvc": "Persianas PVC",
  "cambiar-cinta-persiana": "Cambiar Cinta",
  "reparacion-persianas-malaga": "Reparación",
  "precios-persianas": "Precios",
  "toldos-motorizados": "Toldos Motorizados",
  "toldos-cofre": "Toldos Cofre",
  "toldos-extensibles": "Toldos Extensibles",
  "toldos-veranda": "Toldos Veranda",
  "toldos-balcon": "Toldos Balcón",
  "reparacion-toldos": "Reparación",
  "instalacion-toldos": "Instalación",
  "precios-toldos": "Precios",
  "mosquiteras-enrollables": "Mosquiteras Enrollables",
  "mosquiteras-correderas": "Mosquiteras Correderas",
  "mosquiteras-fijas": "Mosquiteras Fijas",
  "reparacion-mosquiteras": "Reparación",
  malaga: "Málaga",
  marbella: "Marbella",
  fuengirola: "Fuengirola",
  torremolinos: "Torremolinos",
  benalmadena: "Benalmádena",
  mijas: "Mijas",
  estepona: "Estepona",
  nerja: "Nerja",
  "velez-malaga": "Vélez-Málaga",
  ronda: "Ronda",
  antequera: "Antequera",
  "rincon-de-la-victoria": "Rincón de la Victoria",
  "alhaurin-de-la-torre": "Alhaurín de la Torre",
  "alhaurin-el-grande": "Alhaurín el Grande",
  coin: "Coín",
  cartama: "Cártama",
  alora: "Álora",
  benahavis: "Benahavís",
  "san-pedro-de-alcantara": "San Pedro de Alcántara",
};

interface BreadcrumbsProps {
  items?: { name: string; path?: string }[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  const location = useLocation();
  const path = location.pathname;

  if (path === "/") return null;

  let crumbs: { name: string; path?: string }[];

  if (items) {
    crumbs = items;
  } else {
    const segments = path.split("/").filter(Boolean);
    let currentPath = "";
    crumbs = [{ name: "Inicio", path: "/" }];
    segments.forEach((seg, idx) => {
      currentPath += `/${seg}`;
      const isLast = idx === segments.length - 1;
      const label = segmentLabels[seg] || seg.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
      crumbs.push({
        name: label,
        path: isLast ? undefined : currentPath,
      });
    });
  }

  if (crumbs.length <= 1) return null;

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((crumb, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: crumb.name,
      item: crumb.path ? `https://persianas-toldos-malaga.es${crumb.path}` : undefined,
    })),
  };

  return (
    <nav aria-label="Breadcrumb" className="bg-white/90 backdrop-blur-md border-b border-border/50 mt-[64px] md:mt-[72px]">
      <div className="max-w-container mx-auto px-4 md:px-6 py-2.5">
        <ol className="flex items-center gap-1.5 flex-wrap text-xs md:text-sm font-body text-text-secondary" role="list">
          {crumbs.map((crumb, i) => {
            const isLast = i === crumbs.length - 1;
            return (
              <li key={i} className="flex items-center gap-1.5">
                {i > 0 && (
                  <i className="ri-arrow-right-s-line text-text-secondary/40 text-xs" aria-hidden="true"></i>
                )}
                {isLast ? (
                  <span className="font-semibold text-text-primary" aria-current="page">{crumb.name}</span>
                ) : (
                  <Link
                    to={crumb.path || "/"}
                    className="hover:text-primary transition-colors underline-offset-2 hover:underline whitespace-nowrap"
                  >
                    {crumb.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
    </nav>
  );
}